import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { ENDORSE_DISCLAIMER_BEGIN, logError, endorseDisclaimerSuccess, fetchGroups, fetchUsers } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function endorseDisclaimer(action$, state$) {
    return action$.pipe(ofType(ENDORSE_DISCLAIMER_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.acceptDisclaimer()).pipe(switchMap(function(status) {
            var actions = [
                endorseDisclaimerSuccess({
                    status: status
                })
            ];
            if (status) {
                actions.push(fetchGroups(), fetchUsers());
            }
            return actions;
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "endorse_disclaimer"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "endorse_disclaimer"
        }));
    }));
}
